<template>
    <mirrors-redirectors />
</template>

<script>
  import MirrorsRedirectors from '../components/MirrorsRedirectors.vue'
  export default {
    components: {
      MirrorsRedirectors
    }
  }
</script>
